export const isImpact = process.env.REACT_APP_STACK === 'impact'
export const isSec = process.env.REACT_APP_STACK === 'sec'
export const isEmea = process.env.REACT_APP_STACK === 'windrunner' || process.env.REACT_APP_STACK === 'sec'
export const isBrimley = process.env.REACT_APP_STACK === 'brimley'
export const isFlight = process.env.REACT_APP_STACK === 'flight'
